// FETCH ALL FABRIC PO
export const FETCH_FABRIC_PO_MASTER_REQUEST = 'FETCH_FABRIC_PO_MASTER_REQUEST';
export const FETCH_FABRIC_PO_MASTER_SUCCESS = 'FETCH_FABRIC_PO_MASTER_SUCCESS';
export const FETCH_FABRIC_PO_MASTER_FAILURE = 'FETCH_FABRIC_PO_MASTER_FAILURE';

// CREATE FABRIC PO
export const CREATE_FABRIC_PO_MASTER_REQUEST = 'CREATE_FABRIC_PO_MASTER_REQUEST';
export const CREATE_FABRIC_PO_MASTER_SUCCESS = 'CREATE_FABRIC_PO_MASTER_SUCCESS';
export const CREATE_FABRIC_PO_MASTER_FAILURE = 'CREATE_FABRIC_PO_MASTER_FAILURE';

// UPDATE FABRIC PO
export const UPDATE_FABRIC_PO_MASTER_REQUEST = 'UPDATE_FABRIC_PO_MASTER_REQUEST';
export const UPDATE_FABRIC_PO_MASTER_SUCCESS = 'UPDATE_FABRIC_PO_MASTER_SUCCESS';
export const UPDATE_FABRIC_PO_MASTER_FAILURE = 'UPDATE_FABRIC_PO_MASTER_FAILURE';

// FETCH SINGLE STATE OF FABRIC PO
export const FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST = 'FETCH_SINGLE_FABRIC_PO_MASTER_REQUEST';
export const FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS = 'FETCH_SINGLE_FABRIC_PO_MASTER_SUCCESS';
export const FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE = 'FETCH_SINGLE_FABRIC_PO_MASTER_FAILURE';

// DELETE FABRIC PO
export const DELETE_FABRIC_PO_MASTER_REQUEST = 'DELETE_FABRIC_PO_MASTER_REQUEST';
export const DELETE_FABRIC_PO_MASTER_SUCCESS = 'DELETE_FABRIC_PO_MASTER_SUCCESS';
export const DELETE_FABRIC_PO_MASTER_FAILURE = 'DELETE_FABRIC_PO_MASTER_FAILURE';

// FETCH PROPERTY
export const FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST = 'FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_REQUEST';
export const FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS = 'FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_SUCCESS';
export const FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE = 'FETCH_PROPERTY_DATA_FOR_FABRIC_PO_MASTER_FAILURE';

export const RESET_FABRIC_PO_MASTER_INFO = 'RESET_FABRIC_PO_MASTER_INFO';

export const CREATE_FABRIC_PO_MASTER_FORM = 'CREATE_FABRIC_PO_MASTER_FORM';

export const UPDATE_FABRIC_PO_MASTER_FORM = 'UPDATE_FABRIC_PO_MASTER_FORM';

// NAVIGATE TO PARTY DETAILS COMPONENT
export const NAVIGATE_FABRIC_PO_DETAILS = 'NAVIGATE_FABRIC_PO_DETAILS';

// NAVIGATE TO FABRIC PO COMPONENT
export const NAVIGATE_FABRIC_PO_MASTER = 'NAVIGATE_FABRIC_PO_MASTER';
export const FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB = 'FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_TAB';
export const FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE = 'FABRIC_PO_USERFORM_NAVIGATE_TO_DETAIL_REVERSE';

export const FETCH_FABRIC_PO_INVOICE_REQUEST = 'FETCH_FABRIC_PO_INVOICE_REQUEST';
export const FETCH_FABRIC_PO_INVOICE_SUCCESS = 'FETCH_FABRIC_PO_INVOICE_SUCCESS';
export const FETCH_FABRIC_PO_INVOICE_FAILURE = 'FETCH_FABRIC_PO_INVOICE_FAILURE';

export const RESET_FABRIC_PO_INVOICE = 'RESET_FABRIC_PO_INVOICE';

export const UPDATE_FABRIC_PO_REQUEST = 'UPDATE_FABRIC_PO_REQUEST';
export const UPDATE_FABRIC_PO_SUCCESS = 'UPDATE_FABRIC_PO_SUCCESS';
export const UPDATE_FABRIC_PO_FAILURE = 'UPDATE_FABRIC_PO_FAILURE';

export const HEADER_SEARCH_CALL_ONLOAD = 'HEADER_SEARCH_CALL_ONLOAD';

export const NAVIGATE_FABRIC_PO_PRINT = 'NAVIGATE_FABRIC_PO_PRINT'